import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Marquee from "@/components/site/Marquee";
import Founder from "@/components/site/Founder";
import Services from "@/components/site/Services";
import WhyChoose from "@/components/site/WhyChoose";
import Portfolio from "@/components/site/Portfolio";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import Stats from "@/components/site/Stats";
import FAQ from "@/components/site/FAQ";
import CTABanner from "@/components/site/CTABanner";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

const MARQUEE_ITEMS = [
    "3D Visualization",
    "Interior Design",
    "VR Walkthroughs",
    "Structural Planning",
    "Landscape",
    "Church & Institutional",
    "Renovation",
    "Commercial",
];

export default function Home() {
    return (
        <main data-testid="home-page" className="min-h-screen bg-background text-foreground">
            <Header />
            <Hero />
            <About />
            <div className="py-8 md:py-14 border-y hairline overflow-hidden">
                <Marquee items={MARQUEE_ITEMS} duration={45} />
            </div>
            <Founder />
            <Services />
            <WhyChoose />
            <Portfolio />
            <Process />
            <Testimonials />
            <Stats />
            <FAQ />
            <CTABanner />
            <Contact />
            <Footer />
            <FloatingWhatsApp />
        </main>
    );
}
